import en from './en'
import ja from './ja'
import zh from './zh'
import zh_hk from './zh_hk'
import ko from './ko'
import my from './my'
import my_sg from './my_sg'
import sg from './sg'
import zh_sg from './zh_sg'

export default  {
  en,
  ja,
  zh,
  zh_hk,
  ko,
  my,
  my_sg,
  sg,
  zh_sg
}